const STORAGE_KEY = 'caroline.library.guest.v1';

const isReference = (value) => value
    && typeof value.metaId === 'string'
    && value.metaId.length > 0
    && typeof value.mediaType === 'string'
    && value.mediaType.length > 0
    && typeof value.addedAt === 'string';

const createCarolineGuestLibraryStorage = (storage = undefined) => {
    let browserStorage = storage;
    if (browserStorage === undefined) {
        try {
            browserStorage = typeof window !== 'undefined' ? window.localStorage : null;
        } catch (_) {
            browserStorage = null;
        }
    }

    let memoryItems = [];

    return {
        read() {
            try {
                if (!browserStorage) return memoryItems;
                const serialized = browserStorage.getItem(STORAGE_KEY);
                if (serialized === null) return [];
                const parsed = JSON.parse(serialized);
                return Array.isArray(parsed) ? parsed.filter(isReference) : [];
            } catch (_) {
                return memoryItems;
            }
        },
        write(items) {
            memoryItems = items.filter(isReference);
            try {
                browserStorage?.setItem(STORAGE_KEY, JSON.stringify(memoryItems));
            } catch (_) {
                // The in-memory list remains usable when browser storage is blocked.
            }
        },
    };
};

module.exports = { createCarolineGuestLibraryStorage };
